<template>
  <div class="meta-data">
    <span v-if="!metaData">
      There are no metadata fields created in the system for this entity. Create them
      <router-link to="/meta-data-fields" class="lm-link lm-link--tertiary">here.</router-link>
    </span>
    <div v-else class="field-categories">
      <div v-for="(category, key) of metaData" :key="key" class="category">
        <span class="text-weight-regular">{{ key }}</span>

        <q-separator class="q-mb-md" />

        <div class="fields-wrapper">
          <div v-for="(field, index) of category" :key="index" class="field">
            <template v-if="field.type.name === 'text'">
              <q-input
                v-model="field.values"
                :label="`${field.name} ${field.is_required ? '*' : ''}`"
                :hint="field.description"
                :error="showErrors && isInvalid(field)"
                error-message="Required"
                outlined
              />
            </template>

            <template v-if="field.type.name === 'textarea'">
              <q-input
                v-model="field.values"
                :label="`${field.name} ${field.is_required ? '*' : ''}`"
                :hint="field.description"
                :rows="3"
                :error="showErrors && isInvalid(field)"
                error-message="Required"
                type="textarea"
                outlined
              />
            </template>

            <template v-if="field.type.name === 'select'">
              <q-select
                v-model="field.values"
                :error="showErrors && isInvalid(field)"
                :label="`${field.name} ${field.is_required ? '*' : ''}`"
                :hint="field.description"
                :options="getOptions(field.value_options)"
                emit-value
                map-options
                error-message="Required"
                multiple
                outlined
              />
            </template>

            <template v-if="field.type.name === 'checkbox'">
              <q-field
                :error="showErrors && isInvalid(field)"
                :hint="field.description"
                error-message="Required"
                outlined
              >
                <q-checkbox
                  v-model="field.values"
                  :label="`${field.name} ${field.is_required ? '*' : ''}`"
                  color="tertiary"
                  style="margin-left: -10px"
                />
              </q-field>
            </template>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { cloneDeep } from 'lodash'

export default {
  props: {
    metaDataFields: Object
  },

  data() {
    return {
      metaData: null,
      showErrors: false
    }
  },

  watch: {
    metaDataFields: {
      handler(val) {
        this.metaData = cloneDeep(val)
      },
      immediate: true
    }
  },

  methods: {
    isInvalid(field) {
      let hasError = false
      if (field.is_required) {
        if (Array.isArray(field.values) && field.values.length === 0) hasError = true
        else if (!field.values && field.values !== false) hasError = true
      }
      field.error = hasError
      return hasError
    },

    getOptions(collection) {
      return this.generateOptions({
        collection: cloneDeep(collection),
        labelKey: null,
        valueKey: null
      })
    },

    getUpdatedMetaData() {
      // access from parent component
      if (!this.metaDataFields) return null
      Object.entries(this.metaData).forEach(([, fields]) => {
        fields.forEach(field => delete field.error)
      })
      return this.metaData
    },

    triggerValidation() {
      // access from parent
      this.showErrors = true
    },

    resetValidation() {
      // access from parent
      this.showErrors = false
    },

    hasFieldErrors() {
      // access from parent component
      if (!this.metaDataFields) return false
      this.triggerValidation()
      const metaDataFields = Object.entries(this.metaData).reduce((acc, [, fields]) => {
        fields.forEach(field => {
          let hasError = false
          if (field.is_required) {
            if (Array.isArray(field.values) && field.values.length === 0) hasError = true
            else if (!field.values && field.values !== false) hasError = true
          }
          field.error = hasError
          acc.push(field)
        })
        return acc
      }, [])
      return metaDataFields.some(field => field.error)
    }
  }
}
</script>

<style lang="stylus" scoped>
.meta-data {
  width 50%
  display grid
  gap 15px
  padding-bottom 10px

  .field-categories {
    display grid
    gap 20px

    .fields-wrapper {
      display grid
      gap 10px

      .field {
        padding-bottom 10px
        position relative
      }
    }
  }
}
</style>
